import * as React from 'react';
import { Icon } from '../icon';
import { theme } from '../../theme';
import styled from '@emotion/styled';
import { getChipStyles } from './styles';
export const StyledChip = styled.div `
	display: inline-flex;
	position: relative;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	${({ color, transparent }) => getChipStyles(color, transparent)};

	border: none;
	border-radius: 12px;
	padding: ${({ icon }) => (Boolean(icon) ? '0px 8px 0px 2px' : '0px 8px')};

	width: auto;
	max-width: 100%;
	min-height: 24px;
`;
const StyledIcon = styled(Icon) `
	align-self: baseline;
	opacity: 0.7;
`;
const StyledChipText = styled.span `
	${theme.typography.IR90}
	line-height: ${theme.typography.lineHeight.sm};
	color: inherit;
	text-overflow: ellipsis;
	opacity: 0.7;
	white-space: nowrap;
`;
export const Chip = (props) => {
    const { text, icon } = props;
    return (React.createElement(StyledChip, Object.assign({}, props),
        icon && React.createElement(StyledIcon, { name: icon, color: "inherit" }),
        text && React.createElement(StyledChipText, null, text)));
};
//# sourceMappingURL=Chip.js.map